export const colorsToken = {
	colors: {
		neutral: {
			'100': '#f7fafc',
			'200': '#f5f8fc',
			'300': '#cbd5e1',
			'400': '#94a3b8',
			'500': '#64748b',
			'600': '#475569',
			'700': '#334155',
			'800': '#1e293b',
			'900': '#131313',
		},
		primary: {
			'50': '#EDFCF2',
			'200': '#AAF0C4',
			'400': '#3CCB7F',
			'500': '#16B364',
			'600': '#099250',
		},
		success: {
			'50': 'rgba(54, 90, 90, 0.04)',
			'200': '#a8c8c9',
			'400': '#729596',
			'500': '#365a5a',
			'600': '#085d4d',
		},
		info: {
			'50': 'rgba(251, 189, 80, 0.04)',
			'200': '#feeac8',
			'400': '#fccc78',
			'500': '#fbbd50',
			'600': '#faa819',
		},
		error: {
			'50': 'rgba(237, 135, 121, 0.04)',
			'200': '#f2d1ce',
			'400': '#f7c7c1',
			'500': '#ed8779',
			'600': '#e65b48',
		},
		white: '#fff',
		black: '#000',
		mercury: '#e3e6ea',
		'vanilla-ice': '#f4dbd8',
		'lavender-mist': 'rgb(234, 234, 234)',
		'friar-grey': '#7e7e7e',
		'box-shadow': 'rgba(0, 0, 0, 0.09)',
		opal: '#a9c7c8',
		'dust-storm': '#e5cdcb',
		'tufts-blue': 'rgba(58, 104, 192, 0.87)',
		'blue-chalk': '#dfedff',
	},
} as const;
